var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookLogo2019(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-logo-2019",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M50,25A25,25,0,1,0,21.094,49.7V32.232H14.746V25h6.348V19.5c0-6.267,3.732-9.728,9.443-9.728a38.438,38.438,0,0,1,5.6.488v6.153H32.98c-3.106,0-4.074,1.927-4.074,3.9V25H35.84l-1.108,7.228H28.906V49.7A25.009,25.009,0,0,0,50,25Z",
    fill: "#004494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M321.428,221.834l1.077-7.025h-6.74v-4.559c0-1.922.941-3.8,3.96-3.8h3.065v-5.981a37.372,37.372,0,0,0-5.44-.475c-5.551,0-9.179,3.364-9.179,9.455v5.354H302v7.025h6.171v16.982a24.559,24.559,0,0,0,7.594,0V221.834Z",
    transform: "translate(-286.946 -189.112)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo2019);
export default __webpack_public_path__ + "static/media/facebook-logo-2019.5f441bd4d026eda32ed984bad59f8867.svg";
export { ForwardRef as ReactComponent };